<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>
              {{ employeeLeaveRightInit.employee_code }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ employeeLeaveRightInit.firstname_th }}
              {{ employeeLeaveRightInit.lastname_th }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">รหัสพนักงาน</label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="employeeLeaveRight.employee_code"
          readonly
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">ชื่อ</label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="employeeLeaveRight.firstname_th"
          readonly
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">นามสกุล</label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="3"
          v-model="employeeLeaveRight.lastname_th"
          readonly
          outlined
          dense
        ></v-text-field>
        <div
          v-for="leaveRight in employeeLeaveRight.leave_rights"
          :key="leaveRight.leave_rights_uuid"
        >
          <label class="body-2 font-weight-medium">
            {{ leaveRight.title_th }}
          </label>
          <div class="d-flex align-center">
            <div class="flex-grow-1">
              <v-text-field
                v-model.number="leaveRight.day_rights"
                label="วัน"
                type="number"
                min="0"
                max="365"
                class="fix-google-chrome mt-2"
                :rules="[
                  (v) => (v !== null && v !== '') || 'กรุณาใส่ค่า',
                  (v) => /^\d+$/.test(v) || 'กรุณาใส่เฉพาะตัวเลข',
                  (v) => (v >= 0 && v <= 365) || 'กรุณาใส่ค่า 0-365',
                ]"
                tabindex="4"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="flex-grow-1 ml-2">
              <v-text-field
                v-model.number="leaveRight.hour_rights"
                label="ชั่วโมง"
                type="number"
                min="0"
                max="23"
                class="fix-google-chrome mt-2"
                :rules="[
                  (v) => (v !== null && v !== '') || 'กรุณาใส่ค่า',
                  (v) => /^\d+$/.test(v) || 'กรุณาใส่เฉพาะตัวเลข',
                  (v) => (v >= 0 && v <= 23) || 'กรุณาใส่ค่า 0-23',
                ]"
                tabindex="5"
                outlined
                dense
              ></v-text-field>
            </div>
          </div>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center">
          <v-btn
            class="primary mr-3"
            :disabled="
              !isEmployeeLeaveRightDataChange ||
              (uiCtrl &&
                !uiCtrl.isEnable('btn:::leave:leave_rights:employee:update'))
            "
            depressed
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    employeeLeaveRight: {
      type: Object,
    },
    employeeLeaveRightInit: {
      type: Object,
    },
  },
  data() {
    return {
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isEmployeeLeaveRightDataChange() {
      const currentLeaveRights = this.employeeLeaveRight?.leave_rights || []
      const initialLeaveRights = this.employeeLeaveRightInit?.leave_rights || []

      if (currentLeaveRights.length === 0 || initialLeaveRights.length === 0) {
        return false
      }

      const hasDataChange = currentLeaveRights.some((current, index) => {
        const initial = initialLeaveRights[index]
        return (
          current.day_rights !== initial.day_rights ||
          current.hour_rights !== initial.hour_rights
        )
      })

      this.$emit('isEmployeeLeaveRightDataChange', hasDataChange)
      return hasDataChange
    },
  },
  methods: {
    ...mapActions({
      editEmployeeLeaveRight: 'employeeLeaveRight/editEmployeeLeaveRight',
    }),
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const changedLeaveRights =
            this.employeeLeaveRight.leave_rights.filter((current, index) => {
              const initial = this.employeeLeaveRightInit.leave_rights[index]
              return (
                current.day_rights !== initial.day_rights ||
                current.hour_rights !== initial.hour_rights
              )
            })

          await this.editEmployeeLeaveRight({
            company_uuid,
            employee_uuid: this.employeeLeaveRight.employee_uuid,
            data: {
              year_period: this.employeeLeaveRight.year_period + '',
              leave_rights_uuids: changedLeaveRights.map((lr) => ({
                leave_rights_uuid: lr.leave_rights_uuid,
                day_rights: lr.day_rights,
                hour_rights: lr.hour_rights,
              })),
            },
          })

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', this.formAction)
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      }
    },
    onClose() {
      if (this.isEmployeeLeaveRightDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.form.resetValidation()
        this.$emit('formActionCompleted', this.formAction)
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$refs.form.resetValidation()
      this.$emit('formActionCompleted', this.formAction)
    },
    onReset() {
      this.$refs.form.resetValidation()
      this.$emit('onReset', this.formAction)
    },
  },
}
</script>
